import React, { Fragment } from 'react';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

import useClubRenewalRenew from './UseClubRenewalRenew';

import Headings from '@usas/ui-web/components/headings/Headings';
import OfferingTypeRegistrationRadiobuttonList from '../../../components/radiobuttonlists/OfferingTypeRegistrationRadiobuttonList';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';
import Input from '@usas/ui-web/components/inputs/Input';

const ClubRenewalRenew = () => {
  const {
    baseUsasClubState,
    formState,
    errorState,
    clubRenewState,
    clubRegistrationStatusState,
    onFormValueChanged,
    handleSubmit,
    onBackClicked
  } = useClubRenewalRenew();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Club Renewal</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <p className={global.HeaderText}><strong>LSC:</strong>&nbsp;&nbsp;{baseUsasClubState.objData.orgUnit?.parentOrgUnitCode || ''}</p>
          <p className={global.HeaderText}><strong>Club Code:</strong>&nbsp;&nbsp;{baseUsasClubState.objData.orgUnit?.orgUnitCode || ''}</p>
          <p className={global.HeaderText}><strong>Club Name:</strong>&nbsp;&nbsp;{baseUsasClubState.objData.orgUnit?.orgUnitName || ''}</p>
          {clubRegistrationStatusState.objData.canBeRenewed === false && 
          <p className={global.HeaderText}><strong>Status:</strong>&nbsp;&nbsp;{clubRegistrationStatusState.objData.status}</p>
          }
        </div>
      </div>
      {clubRegistrationStatusState.isObjLoaded === true && 
        clubRegistrationStatusState.objData.canBeRenewed === true &&  
        clubRegistrationStatusState.objData.status !== 'Pending Payment' ?
        <Fragment>
          {clubRegistrationStatusState.objData.availableOfferingInstanceId ?
          <form onSubmit={handleSubmit} noValidate>
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12">
                <b>Club Offering:</b> {clubRegistrationStatusState.objData.lastOfferingName}
              </div>
            </div>
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12 col-sm-12 col-md-6 usas-extra-bottom-margin">
                <Input
                  label="Registration Signature"
                  name="registrationSignature"
                  value={formState.registrationSignature}
                  error={errorState.registrationSignature}
                  message={errorState.registrationSignature}
                  onChange={(value) => { onFormValueChanged('registrationSignature', value); }} />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
                <PrimaryButton type="submit">Submit Payment</PrimaryButton>&nbsp;
                <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>
              </div>
            </div>
          </form>
          : <Fragment><p style={{fontSize: 30, color: 'darkgray'}}>{clubRegistrationStatusState.objData.lastOfferingName} offering not available at this time</p></Fragment>
          }
        </Fragment> : <Fragment><p style={{fontSize: 30, color: 'darkgray'}}>Cannot renew at this time</p></Fragment>
      }
      <PopUpModal 
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={clubRegistrationStatusState.isObjLoading || baseUsasClubState.isObjLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={clubRenewState.isSaving} />
    </Fragment>
  );
};

export default ClubRenewalRenew;